import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import strings from "translate/language";
import { visitorDetail } from "reduxStore/action/visitorActions";
import { useDispatch, useSelector } from "react-redux";
import {
  getAge,
  handleDetailResponse,
  hideMobileNumber,
  isJSON,
  seo,
  getCPLeadType,
} from "utils/utils";
import moment from "moment";
import Breadcrumb from "component/common/breadcrumb";
import { genderCheck, visitorStatus, MIS_RoleId } from "utils/constants";
import usePermission from "utils/usePermission";

const ViewVisitor = () => {
  const navigate = useNavigate();
  const [viewData, setViewData] = useState({});
  const params = useParams();
  const { _id: lead_id } = params || {};
  const dispatch = useDispatch();
  const { response: res } = useSelector((state) => state.login);
  const misRole = MIS_RoleId === res?.data?.role_id;

  const visitorDetailSelector = useSelector((state) => state.visitor);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const isCreated = useSelector((state) => {
    const { response } = state.login;
    return viewData?.create_by === handleDetailResponse(response.data)._id
      ? true
      : false;
  });

  const { isAdmin } = usePermission({});

  useEffect(() => {
    dispatch(visitorDetail({ lead_id: lead_id }));
  }, [dispatch, lead_id]);
  useEffect(() => {
    if (visitorDetailSelector.detail) {
      const { response } = visitorDetailSelector;
      if (response?.status === 200) {
        let office_address = {},
          result = {
            ...handleDetailResponse(response.data),
            ...handleDetailResponse(response.data)?.customer_detail,
          };
        let typeofaddress = typeof result?.office_address;
        if (typeofaddress === "string" || typeofaddress === "object") {
          office_address =
            typeofaddress === "object"
              ? result?.office_address
              : isJSON(result?.office_address)
              ? JSON.parse(result?.office_address)
              : null;
          // result.customer_detail = { ...result?.customer_detail, office_address: office_address }
        }
        setViewData(
          handleDetailResponse({ ...result, office_address: office_address })
        );
      }
    }
  }, [visitorDetailSelector]);
  useEffect(() => {
    seo({
      title: "Visitor Details",
      metaDescription: "Visitor details",
      canonicalLink: window.location.href,
    });
  }, []);

  const leadSource =
    viewData?.lead_source === "Reference" && viewData?.referrel_partner === 1
      ? "Referral Partner"
      : viewData?.lead_source || strings.notfount;
  const cpLeadType = getCPLeadType(viewData?.cp_lead_type);

  const capitalizeWords = (text = "") => {
    if (typeof text !== "string") {
      return "";
    }

    return text
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.visitorDetails}
        url={"/visitor"}
        parentListing={strings.visitorList}
        titleactive={strings.viewvisitordetails}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5>{strings.visitorDetails}</h5>
                <div className="card-body">
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.propertyName} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.property_title || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.lastInteracted}
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.last_interacted_date
                          ? moment(viewData?.last_interacted_date).format(
                              "DD-MM-yyyy"
                            )
                          : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.source} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.created_name || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.status} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {visitorStatus[viewData?.lead_status] ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.leadSource} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {leadSource}
                        {cpLeadType}
                      </label>
                    </div>
                  </div>
                  <hr />
                  {viewData?.lead_source === "Reference" && (
                    <>
                      <div className="row">
                        <div className=" col-md-3 align-items-center ">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.referrer} :
                          </label>
                        </div>
                        <div className=" col-md-7 align-items-center ">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.referrer_name}
                          </label>
                        </div>
                      </div>
                      <hr />
                    </>
                  )}
                  {viewData?.leadSource === "Channel Partner" && (
                    <>
                      <div className="row">
                        <div className=" col-md-3 align-items-center ">
                          <label htmlFor="exampleInputMobileNo">
                            {viewData?.cp_type === 2
                              ? "CP Company Name"
                              : "CP Name"}{" "}
                            :
                          </label>
                        </div>
                        <div className=" col-md-7 align-items-center ">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.cp_name
                              ? viewData?.cp_name
                              : strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                    </>
                  )}
                  {viewData?.cp_type === 2 && (
                    <>
                      <div className="row">
                        <div className=" col-md-3 align-items-center ">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.emname} :
                          </label>
                        </div>
                        <div className=" col-md-7 align-items-center ">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {viewData?.cp_emp_name
                              ? viewData?.cp_emp_name
                              : strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                    </>
                  )}

                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.leadStatus} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputQualification"
                        className="boldText"
                      >
                        {viewData?.qualified === true
                          ? strings.qualified
                          : viewData?.qualified === false
                          ? strings.unQualified
                          : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.leadPriority} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {capitalizeWords(viewData?.lead_priority) ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5 className="d-flex justify-content-center">
                  {strings.propertyRequired}
                </h5>
                <div className="card-body">
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.configuration} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {/* {viewData?.customer_detail?.configuration ||
                          strings.notavailable} */}
                        {viewData?.configuration || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.Area} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.areain_sqlft || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />

                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.budget} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {/* {viewData?.min_budget && viewData?.max_budget
                          ? `${viewData?.min_budget}${viewData?.min_budget_type} - ${viewData?.max_budget}${viewData?.max_budget_type}`
                          : strings.notavailable} */}
                        {viewData?.budget_amount
                          ? viewData.budget_amount
                          : viewData?.min_budget && viewData?.max_budget
                          ? `${viewData?.min_budget}${viewData?.min_budget_type} - ${viewData?.max_budget}${viewData?.max_budget_type}`
                          : strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.natureOfFunding}
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.funding_type || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.purpose}
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.purpose || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5 className="d-flex justify-content-center">
                  {strings.customerDetails}
                </h5>
                <div className="card-body">
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.visitorName} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {`${viewData?.customer_detail?.first_name || ""} ${viewData?.customer_detail?.last_name || ""}`.trim() || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.mobileNo} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {/* {viewData?.customer_detail?.mobile ? hideMobileNumber(viewData?.customer_detail?.mobile) : strings.notavailable} */}
                        {viewData?._id
                          ? isCreated
                            ? viewData?.customer_detail?.mobile
                            : viewData?.customer_detail?.mobile
                            ? hideMobileNumber(
                                viewData?.customer_detail?.mobile
                              )
                            : strings.notavailable
                          : viewData?.customer_detail?.mobile}
                      </label>
                    </div>
                  </div>

                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.ethniCity} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.customer_detail?.ethnicity ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.visitingWith} :
                      </label>
                    </div>

                    <div className="col-md-7 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {capitalizeWords(
                          viewData?.customer_detail?.visit_with
                        ) || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.nameOfOccupation}
                      </label>
                    </div>
                    <div className="col-md-7 align-items-center">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {capitalizeWords(
                          viewData?.customer_detail?.occupation
                        ) || strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleLocation">
                        {strings.residentLocation} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label htmlFor="exampleLocation" className="boldText">
                        {viewData?.customer_detail?.location ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleLocation">
                        {strings.workLocation} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label htmlFor="exampleLocation" className="boldText">
                        {viewData?.customer_detail?.office_address ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.age} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {(() => {
                          if (
                            !viewData?.customer_detail?.birth_date ||
                            viewData?.customer_detail?.birth_date === null
                          ) {
                            return strings.notavailable;
                          }
                          const age = getAge(
                            viewData?.customer_detail?.birth_date
                          );
                          return isNaN(age) || age === null || age === undefined
                            ? strings.notavailable
                            : String(age);
                        })()}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.gender} :
                      </label>
                    </div>
                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.customer_detail?.gender === null
                          ? strings.notavailable
                          : genderCheck[viewData?.customer_detail?.gender]}
                      </label>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className=" col-md-3 align-items-center ">
                      <label htmlFor="exampleInputMobileNo">
                        {strings.locality} :
                      </label>
                    </div>

                    <div className=" col-md-7 align-items-center ">
                      <label
                        htmlFor="exampleInputMobileNo"
                        className="boldText"
                      >
                        {viewData?.customer_detail?.locality ||
                          strings.notavailable}
                      </label>
                    </div>
                  </div>
                  <hr />
                </div>
                {!viewData.draft &&
                  Number(viewData?.lead_status) !== 5 &&
                  Number(viewData?.lead_status) !== 6 && (
                    <div className="row">
                      <div className="col-md-6">
                        {!isAdmin && Number(viewData?.lead_status) === 1 && (
                          <div className="card-footer">
                            <button
                              className="btn btn-color"
                              type="submit"
                              onClick={() => {
                                let leadId = lead_id
                                  ? `?lead_id=${lead_id}`
                                  : "";
                                let propertyId = viewData.property_id
                                  ? `&property_id=${viewData.property_id}`
                                  : "";
                                navigatpage(
                                  `/add_appointment${leadId}${propertyId}`
                                );
                              }}
                            >
                              {strings.scheduleSiteVisit}
                            </button>
                          </div>
                        )}
                      </div>
                      {!(isAdmin || misRole) && (
                        <div className="col-md-6 d-flex justify-content-end">
                          <div className="card-footer">
                            <button
                              className="btn btn-color"
                              type="submit"
                              onClick={() => {
                                navigatpage(`/updatestatusfollow/${lead_id}`);
                              }}
                            >
                              {strings.statusUpdate}
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewVisitor;
